import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8424473a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8424473a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8424473a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8424473a')) {
      api.createRecord('8424473a', component.options)
    } else {
      api.reload('8424473a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8424473a&scoped=true", function () {
      api.rerender('8424473a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/callValidPhone/index.vue"
export default component.exports